import React, { useMemo } from "react";
import { Row, Col } from "reactstrap";

import BulkNotificationSignSignerList from "../../../../bulk/notification/sign/signer_list";

import { fetchCustomFieldValue, isAuthorizedCustomFieldToUser } from "../../../../helper/custom_field/helper";

const LaboralBulkNotificationSignForm = props => {
  const {
    currentUser,
    currentCustomer,
    data: {
      securityLayers,
      customFields,
      companies,
      documentTypes
    }
  } = props;

  const hiringStateOptions = [ {value: 'active', label: I18n.t('laboral.hirings.index.tabs.active') }, { value: 'expired', label: I18n.t('laboral.hirings.index.tabs.expired') } ]

  const tableColumnsDefault = [
    {
      field: 'document.entity.company.name',
      header: I18n.t('activerecord.attributes.laboral/hiring.company'),
      filter: {
        enabled: true,
        placeholder: 'Seleccione una empresa',
        inputType: 'simple_select',
        filterrific: {
          search: 'by_company',
        },
        options: _.map(companies, company => ({
          value: company.id,
          label: company.name,
        })),
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'company_name_'
        }
      },
    },
    {
      field: 'email',
      header: I18n.t('activerecord.attributes.signer.email'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el email del firmante',
        inputType: 'text',
        filterrific: {
          search: 'search_by_email'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'email_'
        }
      },
    },
    {
      field: 'name',
      header: I18n.t('activerecord.attributes.signer.name'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre del firmante',
        inputType: 'text',
        filterrific: {
          search: 'search_by_name'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'name_'
        }
      },
    },
    {
      field: 'role',
      header: I18n.t('activerecord.attributes.signer.role'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el rol del firmante',
        inputType: 'text',
        filterrific: {
          search: 'search_by_role'
        }
      },
    },
    {
      field: 'document.entity.employee.name',
      header: I18n.t("activerecord.attributes.laboral/employee.name"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre del empleado',
        inputType: 'text',
        filterrific: {
          search: 'search_by_employee_name'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'employee_name_'
        }
      },
    },
    {
      field: 'document.entity.identifier',
      header: I18n.t("activerecord.attributes.laboral/hiring.identifier"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el identificador de la contratación',
        inputType: 'text',
        filterrific: {
          search: 'search_by_hiring_identifier'
        }
      },
    },
    {
      field: 'document.entity.active_to_s',
      header: 'Estado de Contratación',
      filter: {
        enabled: true,
        placeholder: 'Seleccione un estado de contratación',
        inputType: 'simple_select',
        options: hiringStateOptions,
        filterrific: {
          search: 'by_hiring_state'
        }
      },
    },
    {
      field: 'document.entity.start_date_to_s',
      header: I18n.t("activerecord.attributes.laboral/hiring.start_date"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de inicio de la contratación',
        inputType: 'text',
        filterrific: {
          search: 'search_by_hiring_start_date'
        }
      },
    },
    {
      field: 'document.entity.end_date_to_s',
      header: I18n.t("activerecord.attributes.laboral/hiring.end_date"),
      body: (row) => row?.end_date_to_s || 'Indefinido',
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de fin de la contratación',
        inputType: 'text',
        filterrific: {
          search: 'search_by_hiring_end_date'
        }
      },
    },
    {
      field: 'document.label',
      header: I18n.t("activerecord.attributes.document.label"),
      body: (row) => row?.document?.label || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre del documento',
        inputType: 'text',
        filterrific: {
          search: 'search_by_document_name'
        }
      },
    },
    {
      field: 'document_type.name',
      header: I18n.t("activerecord.attributes.document.document_type"),
      filter: {
        enabled: true,
        placeholder: 'Seleccione un tipo de documento',
        inputType: 'simple_select',
        options: _.map(documentTypes, type => ({
          value: type.id,
          label: type.name,
        })),
        filterrific: {
          search: 'by_document_type'
        }
      },
    },
    {
      field: 'created_at_to_s',
      header: `${I18n.t("activerecord.attributes.signer.created_at")}`,
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de solicitud',
        inputType: 'text',
        filterrific: {
          search: 'search_by_created_at'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'created_at_'
        }
      },
    },
  ]

  const tableColumnSecurityLayer = useMemo(() => {
    if(currentCustomer.security_layer && securityLayers?.length > 0){
      return {
        field: 'employee.security_layer.name',
        header: I18n.t("activerecord.attributes.laboral/employee.security_layer_id"),
        body: (row) => row?.document?.entity?.employee?.security_layer?.name || I18n.t('no_entry'),
        filter: {
          enabled: true,
          placeholder: 'Seleccione una capa de seguridad',
          inputType: 'simple_select',
          options: _.map(securityLayers, securityLayer => ({
            value: securityLayer.id,
            label: securityLayer.name,
          })),
          filterrific: {
            search: 'by_employee_security_layer_id'
          }
        }
      }
    }
  })

  const tableColumnsCustomFields = useMemo(() => {
    return _.map(customFields, function (customField) {
      return {
        field: `document.entity.custom_fields.${ customField.code }`,
        header: _.capitalize(customField.label),
        body: (row) => {
          return fetchCustomFieldValue(customField, row.document.entity.custom_fields[customField.code], currentUser)
        },
        filter: {
          enabled: true,
          placeholder: `Ingrese ${ _.capitalize(customField.label) }`,
          filterrific: {
            search: 'search_by_key_custom_fields',
            searchKey: customField.code
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [])

  const tableColumns = useMemo(() => {
    let columns = _.concat(
      tableColumnSecurityLayer,
      tableColumnsDefault,
      tableColumnsCustomFields
    )

    return _.compact(columns)
  }, [])

  return (
    <Row>
      <Col md="12">
        <BulkNotificationSignSignerList
          dataTableConfiguration={{
            columns: tableColumns
          }}
          configuration={{
            showDistributionListFilter: true,
            context: 'laboral',
            defaultRequestParams: {"filterrific": { "by_aasm_state": "pending" }},
            formName: 'laboral_bulk_notification_sign',
          }}
          routes={{
            indexSignersPath: Routes.laboral_signers_path,
          }}
        />
      </Col>
    </Row>
  );
};

export default LaboralBulkNotificationSignForm;
